import React, { Component } from "react";
import {
  Table,
  FormGroup,
  Button,
  Modal,
  Row,
  Col,
  ControlLabel,
  FormControl
} from "react-bootstrap";
// import Moment from "react-moment";
import { Link } from "react-router-dom";
import { Confirm } from "react-confirm-bootstrap";

class MessageTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
        modalShowing:false,
        list:[],
        editObj: {cat: "", text: "", title: ""},
        deleteDialog:false
    };

  }
  componentDidMount(){
    console.log("Message Table mounted");
  }

  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    if (this.props.answers !== prevProps.answers) {
      let cura=this.props.answers;
      console.log("current response",cura);
      this.setState({list:cura});
    }
  }
  handleEditChange =(e, attribute) =>{
    const target = e.target;
    let temp = Object.assign({}, this.state.editObj);
    temp[attribute] = target.value;
    this.setState({ editObj: temp });
  }
  handleUpdate =() =>{
    //call patch api
    this.setState({modalShowing: false});
    this.props.onUpdate (this.state.editObj);
  }
  handleDelete = (obj) =>{
    //call delete api
    console.log(obj);
    this.props.onDelete(obj);
  }
  

  render() {
    function Td({ children, to }) {
      const content = <Link to={to}>{children}</Link>;

      return <td>{content}</td>;
    }

    //first if statement shows no Messages added if there are no messages
    //Secon one maps objects with their indexes to the table
    const content =
      !this.props.answers || this.props.answers.length === 0 ? (
        <tr>
          <td>No {this.props.objecttype} added</td>
          {this.props.attributes.map((attribute, index) => (
            <td key={index}>No {this.props.objecttype} added</td>
          ))}
        </tr>
      ) : 
      
      (
        this.props.answers.map((obj, index) => (
          <tr key={index}>
            <td>{index + 1}</td>
            <td> {obj.category}</td>
            <td> {obj.text}</td>
            <td> {obj.title}</td>
            <td>
              <Button
                style={{ margin:10 }}
                bsSize="small"
                bsStyle="default"
                onClick={() =>this.setState({ modalShowing: true, editObj: obj })}              >
                Edit
              </Button>
                
                <Confirm
                show={this.state.deleteDialog}
                onConfirm={() => this.handleDelete(obj)}
                body="Are you sure you want to delete this Message?"
                confirmText="Confirm Delete"
                title="Delete Message" >
                <Button
                style={{ marginRight: "10px" }}
                bsSize="small"
                bsStyle="danger"
                onClick={() => this.setState({deleteDialog: true})} >
                DELETE
              </Button>
              </Confirm>
            </td>
          </tr>
        ))
      );

    return (
      <div className="content">
        <Table striped bordered condensed hover>
          <thead>
            <tr>
              <th>#</th>
              {this.props.attributes.map((attribute, index) => (
                <th key={index}>{attribute}</th>
              ))}
              <th>Header</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>{content}</tbody>
        </Table>
        <Modal
          show={this.state.modalShowing}
          onHide={() => this.setState({ modalShowing: false })}
        >
          <Modal.Header closeButton>
            <Modal.Title>Edit Message</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form>
              <FormGroup controlId="formBasicText">
                <Row>
                  <Col xs={8} md={8}>
                    <ControlLabel>Message's Text</ControlLabel>
                    <FormControl
                      type="textarea"
                      componentClass="textarea"
                      style={{minHeight:100 ,marginBottom:10}}
                      value={this.state.editObj.text}
                      placeholder="Enter the text of the message"
                      onChange={(e) => this.handleEditChange(e, "text")}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md={8} xs={8}>
                    <ControlLabel>Title</ControlLabel>
                    <FormControl
                      type="textarea"
                      componentClass="textarea"
                      style={{ minHeight: 50 }}
                      value={this.state.editObj.title}
                      placeholder="Enter the header text"
                      onChange={e => this.handleEditChange(e, "title")}
                    />
                  </Col>
                </Row>
              </FormGroup>
            </form>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="primary" onClick={this.handleUpdate}> Update</Button>
          </Modal.Footer>
        </Modal>

       
      </div>
    );
  }
}

export default MessageTable;



// WEBPACK FOOTER //
// ./src/components/Table/MessageTable.jsx